import { appThemeSize } from "styles/appThemeTokens";

export const HEADER_HEIGHT = appThemeSize.headerHeight;

export const HELP_SUPPORT_PHONE = "1-844-220-2280";

export const getUserInitials = (name = "") =>
  name
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((word) => word.charAt(0).toUpperCase())
    .join("");
